import { lazy } from 'react';

const SectorCreate = lazy(() => import('./SectorCreate'));

export default SectorCreate;
